import {
  Conversation,
  ConversationRequestAction,
} from '@stripe-internal/conversations-client';
import {useEffect} from 'react';
import {filter} from 'rxjs';
import {useRequestAction} from '../../useRequestAction';

export function useConversationRequestedActions(conversation: Conversation) {
  const requestAction = useRequestAction();

  useEffect(() => {
    const sub = conversation
      .eventsObservable()
      .pipe(filter((e) => e.name === 'conversation-request-action'))
      .subscribe((e) => {
        const event = e as ConversationRequestAction;
        const {action, respondWith, responseTimeout} = event;

        requestAction({
          name: 'request-action',
          action,
          responseTimeout,
          waitForResponse: !!respondWith,
        }).then((response) => {
          const data = response.data as Record<string, unknown> | undefined;
          respondWith?.(data);
        });
      });

    return () => sub.unsubscribe();
  }, [conversation, requestAction]);
}
